import {useEffect, useState} from 'react'
import {PageTitle} from '../../_metronic/layout/core'
import carboneSDK from 'carbone-sdk-js'
import GenerateReportModal from '../../components/SomaticTable/GenerateReportModal'
import Swal from 'sweetalert2'
import somaticService from '../../service/somatic'
import runsService from '../../service/runs'
import {useParams} from 'react-router'
import {Loader} from '../../components/Loader'
import axios from 'axios'
import IgvTable from '../../components/SomaticTable/IgvTable'
import TableComponent from '../../components/TableComponent/TableComponent'
import TableComponentTreeData from '../../components/TableComponent/TableComponentTreeData'
import {convertJSONtoTSV, downloadTSV} from '../../utils'
import RunsService from '../../service/runs'
import {Tooltip} from 'react-tooltip'
import {generateReport} from '../../utils/generateReportFormHandler'

const SomaticDetailTable = () => {
  const {id} = useParams()
  const [tableData, setTableData] = useState({snvData: [], svData: [], fusionsData: []})
  const [isFailed, setIsFailed] = useState(false)
  const [snvData, setSnvData] = useState([])
  const [runDetail, setRunDetail] = useState({})
  // const [filteredData, setFilteredData] = useState([])
  const [gridOptions, setGridOptions] = useState(undefined)
  const [snvHeader, setSnvHeader] = useState([])
  const [svHeader, setSvHeader] = useState([])
  const [fusionHeader, setFusionHeader] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(true)
  // const [isAdvanced, setIsAdvanced] = useState(false)
  const [selectedTab, setSelectedTab] = useState()
  const [selectedRow, setSelectedRow] = useState({})
  const [allelicWidgetDatas, setAllelicWidgetDatas] = useState([])
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isDrawerHide, setIsDrawerHide] = useState(false)
  const [isClinic, setIsClinic] = useState(false)
  const [lodSwitch, setLodSwitch] = useState(true)
  const getMatchingData = (array1, array2, variantType) => {
    const matchingData = []
    var filtered = array1.filter((elm) => elm)
    array2.forEach((item) => {
      var matchedChildren = []
      if (variantType === 'snv') {
        matchedChildren = item.Gene_refGene.filter((child) => filtered.includes(child))
        if (matchedChildren.length > 0) {
          matchingData.push({
            ...item,
          })
        }
      } else {
        matchedChildren = item.GeneName.filter((child) => filtered.includes(child))
        if (matchedChildren.length > 0) {
          matchingData.push({
            ...item,
          })
        }
      }
    })
    return matchingData
  }
  const toggleDrawer = () => {
    if (selectedRow.Chrom === undefined) {
      return
    }
    if (isDrawerOpen === true) {
      setIsDrawerHide(!isDrawerHide)
    } else {
      setIsDrawerOpen(true)
    }
  }

  const fetchRunDetail = async () => {
    try {
      const requestId = id.split('&')
      const runDetailResponse = await runsService.getRunDetail(requestId[0])
      if (runDetailResponse.status === 200) {
        setRunDetail(runDetailResponse.data)
      }
      return runDetailResponse.data
    } catch (error) {
      console.error('Failed to fetch run details:', error)
    }
  }

  const fetchVariantData = async (variantType) => {
    try {
      const requestId = id.split('&')
      const variantReq = await somaticService.getSomaticVariants(requestId[0], requestId[1], [
        variantType,
      ])
      if (variantReq.status === 200) {
        var newData = variantReq.data[`${variantType}Data`].rows.map((item) => ({
          ...item,
          reportSelect: '',
        }))
        if (requestId.includes('clinic') && variantType === 'snv') {
          newData = newData.filter((item) => {
            return (
              item?.Filter[0] === 'PASS' &&
              (item?.CancerVar_Tier === 'Tier I strong ' ||
                item?.CancerVar_Tier === 'Tier II potential ' ||
                item?.Oncogenic === 'Oncogenic')
            )
          })
          setIsClinic(true)
        } else if (requestId[3] !== undefined && requestId[3] !== 'clinic') {
          if (variantType !== 'fusions') {
            const geneReq = await RunsService.getGenesListSingle(requestId[3])
            var genesLists = []
            if (geneReq.status === 200) {
              genesLists = geneReq.data.genesLists.map((item) => item.genesList).flat()
            }

            const geneFilteredResult = await getMatchingData(genesLists, newData, variantType)
            newData = geneFilteredResult
          }
        }

        const sortedHeader = variantReq?.data[`${variantType}Data`]?.order.reduce(
          (acc, {name, columnGroup}) => {
            if (variantReq?.data[`${variantType}Data`]?.header.hasOwnProperty(name)) {
              acc[name] = {
                value: variantReq?.data[`${variantType}Data`]?.header[name],
                columnGroup,
              }
            }
            return acc
          },
          {}
        )
        var loeufColumn = {
          loeuf: 'LOEUF',
          columnGroup: null,
        }
        var reportSelect = {
          reportSelect: 'Child',
          columnGroup: null,
        }
        var external = {
          external: 'External',
          columnGroup: null,
        }
        var igv = {
          igv: 'IGV',
          columnGroup: null,
        }
        var finalHeader = {}
        if (variantType === 'sv') {
          finalHeader = {
            reportSelect,
            loeufColumn,
            external,
            igv,
            ...sortedHeader,
          }
        } else {
          finalHeader = {
            reportSelect,
            external,
            igv,
            ...sortedHeader,
          }
        }

        if (variantType === 'sv') {
          newData = newData.map((item) => {
            const start = item.Start
            const end = item.End ? item.End : item.Start
            item.loeufColumn = Math.floor(Math.random() * 10)
            item.igv = item.Chrom + ':' + start + '-' + end
            item.vampp = item.Chrom + ':' + item.Start + '-' + item.Ref + '-' + item.Alt
            return item
          })
        }
        if (variantType === 'snv') {
          setSnvData(newData)
          // if (requestId.includes('clinic')) {
          newData = newData.filter((item) => {
            return item.DET === 'Yes'
          })
          // }

          setSnvHeader(finalHeader)
        }
        if (variantType === 'sv') {
          setSvHeader(finalHeader)
        }
        if (variantType === 'fusions') {
          setFusionHeader(finalHeader)
        }

        setTableData((prev) => ({
          ...prev,
          [`${variantType}Data`]: newData,
        }))
        setIsLoadingData(false)
      }
    } catch (error) {
      console.error('Failed to fetch variant data:', error)
      setIsLoadingData(false)
      setIsFailed(true)
      Swal.fire({
        title: 'Failed to fetch variant data',
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: 'Refresh',
        showCloseButton: false,
        allowOutsideClick: false,
      }).then(() => {
        window.location.reload()
      })
    }
  }
  useEffect(() => {
    const initializeData = async () => {
      setIsLoadingData(true)
      const requestId = id.split('&')
      const detail = await fetchRunDetail()
      if (!detail) return

      let initialTab = 1
      if (detail.processType === 'som-test-rna') {
        initialTab = 3
      } else if (requestId[2] === 'sv') {
        initialTab = 2
      } else if (requestId[2] === 'fusion') {
        initialTab = 3
      }

      setSelectedTab(initialTab)
      setIsLoadingData(false)
    }

    initializeData()
  }, [])

  useEffect(() => {
    const loadVariantData = async () => {
      const tabMapping = {1: 'snv', 2: 'sv', 3: 'fusions'}
      const variantType = tabMapping[selectedTab]
      if (variantType === undefined) return
      if (tableData[`${variantType}Data`] && tableData[`${variantType}Data`].length > 0) {
        return
      }
      setIsLoadingData(true)
      await fetchVariantData(variantType)
    }

    loadVariantData()
  }, [selectedTab])

  const [snvSelectedTableDatas, setSnvSelectedTableDatas] = useState([])
  const [svSelectedTableDatas, setSvSelectedTableDatas] = useState([])
  const [fusionSelectedTableDatas, setFusionSelectedTableDatas] = useState([])

  const [isLoadingReport, setIsLoadingReport] = useState('0')
  const changeSelectedTab = (id) => {
    if (id === selectedTab) return
    setSelectedTab(id)
    setGridOptions(undefined)
  }
  const [reportPayload, setReportPayload] = useState({})

  const generateReportFormHandler = async (type) => {
    if (
      !reportPayload.name ||
      !reportPayload.protocolNo ||
      !reportPayload.referralDate ||
      !reportPayload.referringCenter ||
      !reportPayload.patientName ||
      !reportPayload.referringDoctor
    ) {
      Swal.fire(' Please fill out all fields in the form!', '', 'error')
      return
    }
    try {
      setIsLoadingReport(true)
      await generateReport(type, reportPayload, snvSelectedTableDatas, svSelectedTableDatas, fusionSelectedTableDatas, id)
      setIsLoadingReport(false)
    } catch (error) {
      console.error('Failed to generate report:', error)
    }
    setIsLoadingReport(false)
  }

  useEffect(() => {
    if (isLoadingReport === true) {
      Swal.fire({
        title: 'Generating Report...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })
    } else if (isLoadingReport === false) {
      Swal.close()
      Swal.fire({
        title: 'Report Generated',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
      })
    }
  }, [isLoadingReport])
  const hiddenColumns = [
    'Chrom',
    'Start',
    'End',
    'Ref',
    'Alt',
    'Func_refGene',
    'OMIM',
    'Phenotype_MIM',
    'OrphaNumber',
    'Orpha',
    'ICGC_Id',
    'GT',
    'AD',
    'DET',
  ]
  // if (isLoadingData) {
  //   return (
  //     <div className='row'>
  //       <div className='card card-custom'>
  //         <div className='card-body table-card text-center d-flex align-items-center justify-content-center'>
  //           <Loader />
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }
  // if lodSwitch is true filter the data DET === Yes else show all data
  useEffect(() => {
    setIsLoadingData(true)
    if (lodSwitch) {
      const filteredData = tableData.snvData.filter((item) => item.DET === 'Yes')
      setTableData((prev) => ({
        ...prev,
        snvData: filteredData,
      }))
    } else {
      setTableData((prev) => ({
        ...prev,
        snvData: snvData,
      }))
    }
    setIsLoadingData(false)
  }, [lodSwitch])
  if (isFailed) {
    return (
      <div className='row'>
        <div className='card card-custom'>
          <div className='card-body table-card text-center d-flex align-items-center justify-content-center'></div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className='row '>
        <div className='card card-custom'>
          <div className='card-body table-card'>
            <div className='somatic-detail-table-buttons col-md-12'>
              <h6 className='mb-5 mx-3'>
                {' '}
                {runDetail?.id !== undefined ? runDetail.samples[0].sampleId : ''}
              </h6>

              {(runDetail.processType === 'som-test-tumor-rna' ||
                runDetail.processType === 'som-test-tumor') && (
                <>
                  <span
                    className={` mx-2 btn btn-${selectedTab === 1 ? 'primary' : 'secondary'}`}
                    onClick={() => {
                      if (isLoadingData) return

                      changeSelectedTab(1)
                    }}
                  >
                    SNVs/Short INDELs
                  </span>
                  <span
                    className={` mx-2 btn btn-${selectedTab === 2 ? 'primary' : 'secondary'}`}
                    onClick={() => {
                      if (isLoadingData) return

                      changeSelectedTab(2)
                    }}
                  >
                    Structural Variants/CNVs
                  </span>
                </>
              )}

              {(runDetail.processType === 'som-test-tumor-rna' ||
                runDetail.processType === 'som-test-rna') && (
                <span
                  className={` mx-2 btn btn-${selectedTab === 3 ? 'primary' : 'secondary'} `}
                  onClick={() => {
                    if (isLoadingData) return

                    changeSelectedTab(3)
                  }}
                >
                  Fusion Genes
                </span>
              )}
              {selectedTab === 1 && (
                <div
                  className=' form-check form-switch form-switch-sm form-check-custom form-check-solid'
                  data-tooltip-id='my-tooltip'
                  data-tooltip-content='Within Limit of Detection parameters.'
                  style={{
                    display: 'inline-block',
                  }}
                >
                  <label className='font-weight-bold mx-3'> LoD </label>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    onChange={(e) => setLodSwitch(e.target.checked)}
                    defaultChecked={lodSwitch}
                    name='lodSwitch'
                  />
                </div>
              )}

              <span
                className={` mx-2 btn pull-right btn-dark `}
                onClick={() => {
                  const convertData =
                    selectedTab === 1
                      ? tableData.snvData
                      : selectedTab === 2
                      ? tableData.svData
                      : tableData.fusionsData
                  const tsvData = convertJSONtoTSV(convertData)

                  downloadTSV(tsvData, 'data.tsv')
                }}
              >
                Download as TSV
              </span>
              {snvSelectedTableDatas.length > 0 ||
              svSelectedTableDatas.length > 0 ||
              fusionSelectedTableDatas.length > 0 ? (
                <button
                  className='btn btn-warning pull-right'
                  data-bs-toggle='modal'
                  data-bs-target='#GenerateReportModal'
                >
                  Generate Report
                </button>
              ) : null}
            </div>
            <PageTitle breadcrumbs={[]}>Somatic Details</PageTitle>
            {!isLoadingData ? (
              <>
                <>
                  {selectedTab === 1 && (
                    <TableComponent
                      tableHeader={snvHeader}
                      data={tableData.snvData}
                      isTreeData={false}
                      selectedRows={snvSelectedTableDatas}
                      setSelectedRows={setSnvSelectedTableDatas}
                      gridId={'snvTable'}
                      gridOptions={gridOptions}
                      hiddenColumns={hiddenColumns}
                      setAllelicWidgetDatas={setAllelicWidgetDatas}
                      isClinic={isClinic}
                      setGridOptions={setGridOptions}
                      runId={runDetail?.id}
                      selectedWidgetItem={selectedRow}
                      setSelectedWidgetItem={setSelectedRow}
                    />
                  )}
                  {selectedTab === 2 && (
                    <TableComponentTreeData
                      tableHeader={svHeader}
                      data={tableData.svData}
                      gridOptions={gridOptions}
                      setGridOptions={setGridOptions}
                      selectedRows={svSelectedTableDatas}
                      setSelectedRows={setSvSelectedTableDatas}
                      gridId={'svTable'}
                      selectedWidgetItem={selectedRow}
                      runId={runDetail?.id}
                      setSelectedWidgetItem={setSelectedRow}
                    />
                  )}
                  {selectedTab === 3 && (
                    <TableComponent
                      tableHeader={fusionHeader}
                      data={tableData.fusionsData}
                      isTreeData={false}
                      selectedRows={fusionSelectedTableDatas}
                      setSelectedRows={setFusionSelectedTableDatas}
                      gridId={'fusionsTable'}
                      hiddenColumns={[]}
                      setAllelicWidgetDatas={setAllelicWidgetDatas}
                      gridOptions={gridOptions}
                      setGridOptions={setGridOptions}
                      selectedWidgetItem={selectedRow}
                      setSelectedWidgetItem={setSelectedRow}
                    />
                  )}
                </>
              </>
            ) : (
              <div className='card-body table-card text-center d-flex align-items-start justify-content-center'>
                <Loader />
              </div>
            )}
          </div>
        </div>
        <GenerateReportModal
          generateReportFormHandler={generateReportFormHandler}
          setIsLoadingReport={setIsLoadingReport}
          snvSelectedTableDatas={snvSelectedTableDatas}
          svSelectedTableDatas={svSelectedTableDatas}
          fusionSelectedTableDatas={fusionSelectedTableDatas}
          id={id}
          runDetail={runDetail}
          reportPayload={reportPayload}
          setReportPayload={setReportPayload}
        />

        {selectedTab === 1 && isFailed === false && (
          <div className={`table-ivg`} style={{position: 'relative'}}>
            <IgvTable
              isDrawerOpen={isDrawerOpen}
              toggleDrawer={toggleDrawer}
              allelicWidgetDatas={allelicWidgetDatas}
              selectedTab={selectedTab}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
            />
          </div>
        )}
        <Tooltip id='my-tooltip' />
      </div>
    </>
  )
}

export {SomaticDetailTable}
